import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import routes from "./routes"; // Import cấu hình routes từ router.js
import store from "@/state/store"; // Cần thiết để kiểm tra trạng thái đăng nhập

Vue.use(VueRouter);
Vue.use(VueMeta, {
  keyName: "page",
});

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// GLOBAL BEFORE EACH GUARD: Bắt đầu xử lý bảo vệ route VÀ KÍCH HOẠT LOADING
router.beforeEach((to, from, next) => {
  // KÍCH HOẠT LOADING TRƯỚC KHI BẮT ĐẦU CHUYỂN TRANG
  // FIX: Sử dụng action từ module 'app' (Giả định đã đăng ký)
  store.dispatch("app/setLoading", true);

  // 1. Kiểm tra xem route có yêu cầu xác thực không (meta: { requiresAuth: true })
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 2. KIỂM TRA DỰA VÀO TOKEN TRONG LOCAL STORAGE
    const token = localStorage.getItem("user-token");
    const loggedIn = token !== null && token !== undefined && token !== "";

    if (!loggedIn) {
      // Nếu token không tồn tại/rỗng, chuyển hướng đến trang đăng nhập
      next({
        path: "/login",
        // Lưu lại đường dẫn đích để quay lại sau khi đăng nhập
        query: { redirect: to.fullPath },
      });
    } else {
      // Đã đăng nhập, cho phép truy cập
      next();
    }
  } else {
    // Route không yêu cầu xác thực (là public page), cho phép truy cập
    next();
  }
});

// Giữ lại router.beforeResolve cũ nếu nó thực hiện các tác vụ async khác (ví dụ: pre-fetching)
router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }
  next();
});

// GLOBAL AFTER EACH HOOK (Tắt Loading)
router.afterEach(() => {
  // Tắt trạng thái Loading sau khi chuyển trang xong (đã load xong component)
  // Delay 1 giây (1000ms) để người dùng kịp thấy hiệu ứng Loading
  setTimeout(() => {
    // FIX: Sử dụng action từ module 'app' (Giả định đã đăng ký)
    store.dispatch("app/setLoading", false);
  }, 500);
});

export default router;
